import React__default from 'react';

const ProfileImage = ({ name, buttonStyle, onClick, buttonClassName, iconVisible, path }) => {
    return (React__default.createElement("button", { onClick: (event) => onClick(event), className: `${buttonClassName}`, style: Object.assign({}, buttonStyle) },
        iconVisible ? path : null,
        " ",
        name));
};

export { ProfileImage as default };
//# sourceMappingURL=Button.js.map
